import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Basic i18n setup with English (en) and Brazilian Portuguese (pt-BR)
// Add or adjust keys as the app grows. Default language is pt-BR to preserve current UX.

const resources = {
  en: {
    common: {
      loading: 'Loading...',
      retry: 'Try again',
      back: 'Back',
      save: 'Save',
      saving: 'Saving…',
      saved: 'Saved.',
      name: 'Name',
      firstName: 'First name',
      lastName: 'Last name',
      cellphone: 'Cellphone',
      language: 'Preferred language',
      status: 'Active',
    },
    app: {
      appName: 'Canhoto Simples',
      logout: 'Logout',
      userPreferences: 'Preferences',
      changePassword: 'Change password',
      notifications: 'Notifications',
    },
    auth: {
      login: 'Sign in',
      username: 'Username',
      password: 'Password',
      signIn: 'Sign in',
      signingIn: 'Signing in…',
      username_required: 'Username is required',
      password_required: 'Password is required',
    },
    deliveries: {
      title: 'Deliveries',
      loading: 'Loading deliveries…',
      load_error: 'Failed to load deliveries.',
      register_pod: 'Register POD',
      empty: 'No deliveries to show right now.',
      empty_hint: 'As soon as there are deliveries available for you, they will appear here.',
    },
    pod: {
      title: 'Register POD',
      received_by_name: 'Received by (name)',
      document_optional: 'Document (optional)',
      observations: 'Observations',
      status: 'Status',
      status_delivered: 'Delivered',
      status_failed: 'Failed',
      status_partial: 'Partial',
      photo: 'Photo',
      signature: 'Signature',
      save_signature: 'Save signature',
      clear: 'Clear',
      location: 'Location',
      submit: 'Submit',
      submitting: 'Submitting…',
      back: 'Back',
      save_signature_first: 'Please save the signature before submitting.',
      enter_recipient_name: 'Please enter the recipient name.',
      observations_required: 'Please provide the reason in observations.',
      photos_required: 'Please upload at least one photo.',
    },
    errors: {
      generic: 'Something went wrong. Please try again.',
      invalid_credentials: 'Invalid credentials',
      login_failed: 'Login failed',
      pod_submit_failed: 'Failed to submit POD. It will be queued for offline submission.',
      upload_failed: 'File upload failed',
    },
  },
  'pt-BR': {
    common: {
      loading: 'Carregando...',
      retry: 'Tentar novamente',
      back: 'Voltar',
      save: 'Salvar',
      saving: 'Salvando…',
      saved: 'Salvo.',
      name: 'Nome',
      firstName: 'Nome',
      lastName: 'Sobrenome',
      cellphone: 'Celular',
      language: 'Idioma preferido',
      status: 'Ativo',
    },
    app: {
      appName: 'Canhoto Simples',
      logout: 'Sair',
      userPreferences: 'Preferências',
      changePassword: 'Alterar senha',
      notifications: 'Notificações',
    },
    auth: {
      login: 'Entrar',
      username: 'Usuário',
      password: 'Senha',
      signIn: 'Entrar',
      signingIn: 'Entrando…',
      username_required: 'Informe o usuário',
      password_required: 'Informe a senha',
    },
    deliveries: {
      title: 'Entregas',
      loading: 'Carregando entregas…',
      load_error: 'Erro ao carregar entregas.',
      register_pod: 'Registrar Entrega',
      empty: 'Nenhuma entrega para exibir no momento.',
      empty_hint: 'Assim que houver entregas disponíveis para você, elas aparecerão aqui.',
    },
    pod: {
      title: 'Registrar Entrega',
      received_by_name: 'Recebido por (nome)',
      document_optional: 'Documento (opcional)',
      observations: 'Observações',
      status: 'Status',
      status_delivered: 'Entregue',
      status_failed: 'Falhou',
      status_partial: 'Parcial',
      photo: 'Foto',
      signature: 'Assinatura',
      save_signature: 'Salvar Assinatura',
      clear: 'Limpar',
      location: 'Localização',
      submit: 'Enviar',
      submitting: 'Enviando…',
      back: 'Voltar',
      save_signature_first: 'Salve a assinatura antes de enviar.',
      enter_recipient_name: 'Informe o nome de quem recebeu.',
      observations_required: 'Informe o motivo nas observações.',
      photos_required: 'Envie pelo menos uma foto.',
    },
    errors: {
      generic: 'Algo deu errado. Tente novamente.',
      invalid_credentials: 'Credenciais inválidas',
      login_failed: 'Falha no login',
      pod_submit_failed: 'Falha ao enviar POD. Será enfileirado para envio offline.',
      upload_failed: 'Falha no upload do arquivo',
    },
  },
  es: {
    common: {
      loading: 'Cargando...',
      retry: 'Intentar de nuevo',
      back: 'Volver',
      save: 'Guardar',
      saving: 'Guardando…',
      saved: 'Guardado.',
      name: 'Nombre',
      firstName: 'Nombre',
      lastName: 'Apellido',
      cellphone: 'Celular',
      language: 'Idioma preferido',
      status: 'Activo',
    },
    app: {
      appName: 'Canhoto Simples',
      logout: 'Salir',
      userPreferences: 'Preferencias',
      changePassword: 'Cambiar contraseña',
      notifications: 'Notificaciones',
    },
    auth: {
      login: 'Iniciar sesión',
      username: 'Usuario',
      password: 'Contraseña',
      signIn: 'Entrar',
      signingIn: 'Ingresando…',
      username_required: 'El usuario es obligatorio',
      password_required: 'La contraseña es obligatoria',
    },
    deliveries: {
      title: 'Entregas',
      loading: 'Cargando entregas…',
      load_error: 'Error al cargar entregas.',
      register_pod: 'Registrar Entrega',
      empty: 'No hay entregas para mostrar en este momento.',
      empty_hint: 'Tan pronto como haya entregas disponibles para ti, aparecerán aquí.',
    },
    pod: {
      title: 'Registrar Entrega',
      received_by_name: 'Recibido por (nombre)',
      document_optional: 'Documento (opcional)',
      note: 'Nota',
      photo: 'Foto',
      signature: 'Firma',
      save_signature: 'Guardar firma',
      clear: 'Limpiar',
      location: 'Ubicación',
      submit: 'Enviar',
      submitting: 'Enviando…',
      back: 'Volver',
      save_signature_first: 'Guarde la firma antes de enviar.',
      enter_recipient_name: 'Ingrese el nombre del destinatario.',
    },
    errors: {
      generic: 'Algo salió mal. Inténtalo de nuevo.',
      invalid_credentials: 'Credenciales inválidas',
      login_failed: 'Error al iniciar sesión',
      pod_submit_failed: 'Error al enviar POD. Se pondrá en cola para envío sin conexión.',
      upload_failed: 'Error al subir archivo',
    },
  },
}

void i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt-BR', // default language
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    defaultNS: 'common',
  })

export default i18n
